// extracted by mini-css-extract-plugin
export default {"header":"wdjms","scroller":"dDmVm","item":"WWIHE","item_icon":"bXXoI","item_link":"xA5PB"};